import styled from 'styled-components';
export const Container = styled.li `
  display: flex;
  align-items: center;
`;
